import { apiClient } from "./apiClient"

const getSegmentsData = async (callId: string, fileName: string) => {
    const {data} = await apiClient.get(`/segments/${callId}/${fileName}`)
    return data.data.content
}

const getSegmentsAnalytics = async (callId: string, fileName: string) => {
    const {data} = await apiClient.get(`/segments/analytics/${callId}/${fileName}`)
    return data
}

export const segmentsApiService = {
    getSegmentsData,
    getSegmentsAnalytics,
}